import { Typography, useMediaQuery } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';

import FilledButton from '@/components/FilledButton.jsx';
import OutlinedButton from '@/components/OutlinedButton.jsx';

import { BookingStep } from '@/utils/constants.js';

import { useBookingStore } from '@/store.js';

const useStyles = makeStyles((theme: any) => ({
    container: {
        display: 'flex',
        padding: '1rem 0',
        gap: '1rem',

        [theme.breakpoints.down('xs')]: {
            flexDirection: 'column',
        },
    },
    card: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        gap: '0.75rem',
        padding: '1.5rem',
        background: theme.palette.common.lightGray,
        border: '1px solid #d5d5d5',
        borderRadius: '0.5rem',
    },
    cardHeading: {
        fontWeight: 700,
    },
    cardText: {
        color: '#686868',
    },
    cardButton: {
        display: 'flex',
        marginTop: 'auto',
        paddingTop: '0.75rem',
    },
}));

export const AuthSelection = () => {
    const classes = useStyles();
    const { t } = useTranslation();
    const theme = useTheme();
    const matchesXs = useMediaQuery(theme.breakpoints.down('xs'));

    return (
        <div className={classes.container}>
            <div className={classes.card}>
                <Typography className={classes.cardHeading}>{t('AuthSelectionRegisterHeading')}</Typography>
                <Typography className={classes.cardText}>{t('AuthSelectionRegisterText')}</Typography>
                <div className={classes.cardButton}>
                    <FilledButton
                        text={t('Register')}
                        fullWidth={matchesXs}
                        onPress={() => useBookingStore.setState({ currentStep: BookingStep.REGISTRATION })}
                        dataTestId="booking-auth-register-btn"
                    />
                </div>
            </div>
            <div className={classes.card}>
                <Typography className={classes.cardHeading}>{t('AuthSelectionLoginHeading')}</Typography>
                <Typography className={classes.cardText}>{t('AuthSelectionLoginText')}</Typography>
                <div className={classes.cardButton}>
                    <OutlinedButton
                        text={t('Login')}
                        fullWidth={matchesXs}
                        onPress={() => useBookingStore.setState({ showLoginModal: true })}
                        dataTestId="booking-auth-signin-btn"
                    />
                </div>
            </div>
        </div>
    );
};
